import TID300Measurement from "./TID300Measurement.js";
import unit2CodingValue from "./unit2CodingValue.js";

export default class Length extends TID300Measurement {
    contentItem() {
        const {
            point1,
            point2,
            unit = "mm",
            distance,
            ReferencedSOPSequence
        } = this.props;

        return this.getMeasurement([
            {
                RelationshipType: "CONTAINS",
                ValueType: "NUM",
                ConceptNameCodeSequence: {
                    CodeValue: "G-D7FE",
                    CodingSchemeDesignator: "SRT",
                    CodeMeaning: "Length"
                },
                MeasuredValueSequence: {
                    MeasurementUnitsCodeSequence: unit2CodingValue(unit),
                    NumericValue: distance
                },
                ContentSequence: [
                    {
                        RelationshipType: "INFERRED FROM",
                        ValueType: "SCOORD",
                        GraphicType: "POLYLINE",
                        GraphicData: [point1.x, point1.y, point2.x, point2.y],
                        ContentSequence: {
                            RelationshipType: "SELECTED FROM",
                            ValueType: "IMAGE",
                            ReferencedSOPSequence
                        }
                    }
                ].concat(this.getLabelLocationGroups())
            }
        ]);
    }
}
